import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  nested: {
    width: '100%',
    // @ts-ignore
    paddingLeft: theme.spacing(4),
  },
}))

export default useStyles
